import { Attributes, NeoModel, ValueObject } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";

@NeoModel
export default class GetExportFileSpecDateOverlapQuery extends ValueObject {
    public staticExportFileSpecId: number = 0;

    public exportName: string = "";

    public exportReportReference: string = "";

    public format: string = "";

    @Attributes.Date(TimeZoneFormat.None)
    public activeStartDate: Date | null = null;
}